import photoUrl from "../../assets/images/uploadFileIcon.png";

const UploadImage = ({ onFileUpload, name, image, noCirle, size, imageUrl }) => {
  return (
    <div
      className={`${!noCirle && "rounded-circle"} text-center ${
        size ? size : "w-100 h-100"
      }`}
    >
      <label className="text-center d-flex p-cursor">
        {image ? (
          <>
            <input
              type="file"
              onChange={onFileUpload}
              name={name}
              className="d-none"
              accept="image/*"
            />
            <img
              src={URL.createObjectURL(image)}
              alt=""
              className={`${size ? size : "w-100 h-100"} img-fluid rounded`}
            />
          </>
        ) : imageUrl ? (
          <>
            <input
              type="file"
              onChange={onFileUpload}
              name={name}
              className="d-none"
              accept="image/*"
            />
            <img
              src={imageUrl}
              alt="display"
              className={`${size ? size : "w-100 h-100"} img-fluid rounded`}
            />
          </>
        ) : (
          <>
            <input
              type="file"
              onChange={onFileUpload}
              name={name}
              className="d-none"
              accept="image/*"
            />
            <img
              src={photoUrl}
              alt="pics"
              className={`${size ? size : "w-100 h-100"} img-fluid rounded`}
            />
          </>
        )}
      </label>
      {/* <p className="fw-bold">Upload</p> */}
    </div>
  );
};

export default UploadImage;
